import { cards } from 'constants/cards';
import { getCurrencyTypeInURLFormat, getLocaleUrlPath } from './i18n';

export const getHrefAllBanks = ({ currency, city, date, locale }) => {
  const getCurrency = currency ? `${currency}/` : '';
  const getCity = city ? `${city}/` : '';
  const getDate = date ? `${date}/` : '';

  return `https://${process.env.APP_DOMAIN}${getLocaleUrlPath(
    locale
  )}/currency/banks/${getCity}${getCurrency}${getDate}`;
};

export const getHrefBank = (bank, locale) => {
  return `https://${process.env.APP_DOMAIN}${getLocaleUrlPath(
    locale
  )}/company/${bank}/`;
};

export const getBankLogo = logo => {
  return `https://${process.env.APP_DOMAIN}${logo}`;
};

export const getHrefExchanger = ({ id, citySlug, locale }) => {
  const url = `https://${process.env.APP_DOMAIN}${getLocaleUrlPath(locale)}${
    process.env.APP_VA_PREFIX_DOMAIN
  }/${citySlug}/id-${id}/`;

  return url;
};
export const getHrefAllExchangers = ({ locale, currency, city }) => {
  const currencyPart = currency ? `${currency}/` : '';
  const cityPart = city ? `${city}/` : '';

  return `https://${process.env.APP_DOMAIN}${getLocaleUrlPath(
    locale
  )}/currency/auction/${currencyPart}buy/${cityPart}`;
};
export const getHrefCurrency = (path, locale) => {
  return `https://${process.env.APP_DOMAIN}${getLocaleUrlPath(
    locale
  )}${`/currency${path}`}`;
};

export const getCurrencyUrl = ({ city, date, currency, dataSource }) => {
  const dataSourceParam = dataSource ? `${dataSource}/` : '';
  const cityParam = city ? `${city}/` : '';
  const dateParam = date ? `${date}/` : '';
  const currencyParam = currency ? `${currency}/` : '';

  return `/${dataSourceParam}${cityParam}${currencyParam}${dateParam}`;
};

export const getConverterLandingUrl = ({
  sourceValue,
  sourceCurrency,
  sourceType,
  targetCurrency,
  targetType,
}) =>
  `/converter/${sourceValue}-${sourceCurrency.toLowerCase()}${getCurrencyTypeInURLFormat(
    sourceType
  )}-to-${targetCurrency.toLowerCase()}${getCurrencyTypeInURLFormat(
    targetType
  )}/`;

export const getUrlByCardType = (type, locale) => {
  if (type === cards.mc) {
    return `https://minfin.com.ua${getLocaleUrlPath(
      locale
    )}/currency/mastercard/`;
  }

  return `https://minfin.com.ua${getLocaleUrlPath(locale)}/currency/${type}/`;
};
